// 明道云 API 配置
export const MINGDAO_APP_KEY = 'a408c722a0d82946'
export const MINGDAO_SIGN = 'YTYzNWVhNWM4YTAxMWNkYWU3Mzg4ZTc2OTE4YzZhOGZmNjdlMWNiZWQyNGQzZTQ3MTY2MDY5M2E2ZGU1Nzc3Yg=='
export const MINGDAO_API_BASE = 'https://api.mingdao.com/v2/open/worksheet'
export const REFRESH_JU_DANS_WEBHOOK = 'https://api.mingdao.com/workflow/hooks/NjY5Y2MwOTYzOTBkOWI1NTAzODJiYjhj'
export const DEFAULT_OWNER_ID = 'a3326b15-f1b9-4828-ab45-00069710d9cc'

// 工作表 ID
export const WORKSHEETS = {
  ACCOUNT: 'zhanghao',
  JU: 'ju',
  DAN: 'dan',
}

// 视图 ID
export const VIEWS = {
  DAN_DEFAULT: '669cc097ec7f7f0422c898c4',
}

// 账号表字段
export const ACCOUNT_FIELDS = {
  NAME: '66895b3a8c68dc973221e386',
  LIANHONG: '6695154ef234e4ca8040548b',
  USER_TOKEN: '66895b3a8c68dc973221e388',
  USER_ID: '69e355c77c48e6078a71023a',
  // '1'=在备选池, '0'=可用
  IS_POOL: '668faebf8c68dc973227f3f3',
  SEQUENCE: '69eca2996e2709faf5ad1aff',
  FILTER_FLAG: '66992ba26c73406b926bb554',
}

// 局表字段
export const JU_FIELDS = {
  NAME: '6689eef14357f965f8dd64ff',
  STAGE: '668a12678c7c10c3a1f3f64d',
  ROW: '668fbfe68c68dc9732280e10',
  NUMBER: '668a02540207cf7520fc99b7',
}

// 单表字段
export const DAN_FIELDS = {
  NAME: '6689ef2e711a07e88b2f8381',
  JU_ID: '6689f1e24357f965f8dd6719',
  ACCOUNT: '6689fe42ca758c8cc5ccfe54',
  LIANHONG: '66952478f234e4ca80405f16',
  ACCOUNT_ROWID: '66924a0df52e2a006162e0aa',
  GROUP_INDEX: '66964626c8525c1f88c4195a',
  ROW: '668a0731790c0e040587af55',
  AWARD_STATUS: '668a05b7ac7cb8ff7117787c',
  DISABLE_BULK: '669918c67714267c1f048fa6',
  TAO_ORDER_ID: '668f8cdfb80969563ecf38fe',
  TAO_ORDER_STATUS: '668f8debd70d332b25de5c80',
  USER_TOKEN: '69ecb7895f233e7d9d7c1273',
  USER_ID: '69ecba4d535a8e55266034c1',
}
